import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAuthGuardService } from 'app/core/security/guards/app-auth-guard.service';
import { LayoutComponent } from 'app/layout/layout-component/layout.component';
import { DashboardComponent } from '../components/dashboard/dashboard.component';
import { WelcomeComponent } from '../components/welcome/welcome.component';
import { HubComponent } from '../components/hub/hub.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    component: LayoutComponent,
    canActivate: [AppAuthGuardService],
    children: [
      {
        path: '',
        loadChildren: () => import('app/modules/configuration/configuration.module').then(m => m.ConfigurationModule),
      },
      {
        path: '',
        loadChildren: () => import('app/modules/customer/customer.module').then(m => m.CustomerModule),
      },
      {
        path: '',
        loadChildren: () => import('app/modules/contacts/contacts.module').then(m => m.ContactsModule),
      },
      {
        path: '',
        loadChildren: () => import('app/modules/service-agreements/service-agreements.module').then(m => m.ServiceAgreementModule),
      },
      {
        path: '',
        loadChildren: () => import('app/modules/my-cases/my-cases.module').then(m => m.MyCasesModule),
      },
      {
        path: '',
        loadChildren: () => import('app/modules/my-services/my-services.module').then(m => m.MyServicesModule),
      },
      {
        path: '',
        loadChildren: () => import('app/modules/my-resources/my-resources.module').then(m => m.MyResourcesModule),
      },
      {
        path: '',
        loadChildren: () => import('app/modules/my-documents/my-documents.module').then(m => m.MyDocumentsModule),
      },
      {
        path: 'welcome',
        component: WelcomeComponent,
        data: { title: 'Welcome' },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { title: 'Dashboard' },
      },
      {
        path: 'hub',
        component: HubComponent,
        data: { title: 'Hub' },
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class LayoutRoutesModule {}
